<template>
  <div>결제 처리중...</div>
</template>

<script>
export default {
  mounted() {
    // 부모창에 결과 전달
    if (window.opener && !window.opener.closed) {
      window.opener.postMessage({
        type: 'MOBILIANS_PAYMENT_RESULT',
        status: this.$route.query.status,
        tid: this.$route.query.tid
      }, window.location.origin);
    }

    // 팝업 닫기
    window.close();
  }
};
</script>